var PES = PES || {};

PES.Resources = {
    FieldRequired: ko.observable(""),
    FieldExceedsCharacterLimit: ko.observable(""),
    NotValidEmailAddress: ko.observable(""),
    DefaultErrorMessage: ko.observable(""),
    InvalidBillingErrorMessage: ko.observable(""),
    IncorrectPassword: ko.observable(""),
    EmailConfirmationRequired: ko.observable(""),
    CustomerResellerNote: ko.observable(""),
    ResellerLoginAsCustomer: ko.observable(""),
    ForgotPasswordSentMessage: ko.observable(""),
    SignInorRegister: ko.observable(""),
    SignIn: ko.observable(""),
    Register: ko.observable(""),
    SignedInAs: ko.observable(""),
    SignedInAsReseller: ko.observable(""),
    AsReseller: ko.observable(""),
    ReviewCart: ko.observable(""),
    PaymentInformation: ko.observable(""),
    AccountDetails: ko.observable(""),
    ResellerDetails: ko.observable(""),
    YourCustomerDetails: ko.observable(""),
    ResendLink: ko.observable(""),
    ResetPassword: ko.observable(""),
    CustomerEmailSameAsReseller: ko.observable(""),
    OrderExpired: ko.observable(""),
    BasketChanged: ko.observable(""),
    OrderNoCreditCard: ko.observable(""),
    IdenticalEmailDomainMessage: ko.observable(""),
    OrderPaid: ko.observable(""),
    PaymentInProgress: ko.observable(""),
    ErrorInvalidData: ko.observable(""),
    PaymentIntentExists: ko.observable(""),
    SecureLayerText: ko.observable(""),
    DisplayResetPasswordExpiredMessage: ko.observable(""),
    DisplayForceLoggedOutMessage: ko.observable(""),
    MaximumLengthExceededMessage: ko.observable(""),
    UnsupportedCharacters: ko.observable(""),

    loadResources: function () {
        var self = this;
        $.ajax({
            async: false,
            type: "GET",
            url: "api/resources",
            success: function (resources) {
                self.FieldRequired(resources.FieldRequired);
                self.FieldExceedsCharacterLimit(resources.FieldExceedsCharacterLimit);
                self.NotValidEmailAddress(resources.NotValidEmailAddress);
                self.EmailConfirmationRequired(resources.EmailConfirmationRequired);
                self.CustomerResellerNote(resources.CustomerResellerNote);
                self.DefaultErrorMessage(resources.DefaultErrorMessage);
                self.InvalidBillingErrorMessage(resources.InvalidBillingErrorMessage);
                self.IncorrectPassword(resources.IncorrectPassword);
                self.ResellerLoginAsCustomer(resources.ResellerLoginAsCustomer);
                self.ForgotPasswordSentMessage(resources.ForgotPasswordSentMessage);
                self.SignInorRegister(resources.SignInorRegister);
                self.SignIn(resources.SignIn);
                self.Register(resources.Register);
                self.SignedInAs(resources.SignedInAs);
                self.SignedInAsReseller(resources.SignedInAsReseller);
                self.AsReseller(resources.AsReseller);
                self.ReviewCart(resources.ReviewCart);
                self.PaymentInformation(resources.PaymentInformation);
                self.AccountDetails(resources.AccountDetails);
                self.ResellerDetails(resources.ResellerDetails);
                self.YourCustomerDetails(resources.YourCustomerDetails);
                self.ResendLink(resources.ResendLink);
                self.ResetPassword(resources.ResetPassword);
                self.CustomerEmailSameAsReseller(resources.CustomerEmailSameAsReseller);
                self.OrderExpired(resources.OrderExpired);
                self.BasketChanged(resources.BasketChanged);
                self.OrderNoCreditCard(resources.OrderNoCreditCard);
                self.IdenticalEmailDomainMessage(resources.IdenticalEmailDomainMessage);
                self.OrderPaid(resources.OrderPaid);
                self.PaymentInProgress(resources.PaymentInProgress);
                self.ErrorInvalidData(resources.ErrorInvalidData);
                self.PaymentIntentExists(resources.PaymentIntentExists);
                self.SecureLayerText(resources.AdditionalLayer);
                self.DisplayResetPasswordExpiredMessage(resources.DisplayResetPasswordExpiredMessage);
                self.DisplayForceLoggedOutMessage(resources.DisplayForceLoggedOutMessage);
                self.MaximumLengthExceededMessage(resources.MaximumLengthExceededMessage);
                self.UnsupportedCharacters(resources.UnsupportedCharactersMessage);
            }
        });
    }
}
